<template>
  <router-link v-bind:to="`property/${data._id}`">
    <div class="propertyCard">
      <img :src="getImage(data)" />
      <div class="detailContainer">
        <div class="row-1">
          <h5>
            <b>{{data.property.buildingName}}</b>
            <span>{{data.property.block}}</span>
          </h5>
          <div
            class="status"
            :class="data.status"
          >{{getStatusName(data.status)}}</div>
        </div>
        <div class="row-2">
          <div>{{data.property.floor}}-{{data.property.unit}}</div>
          <div class="price">
            <div v-if="data.status==='forSellAndRent'">HKD {{_.round(data.sellPrice)}}萬/月租{{_.round(data.rentPrice)}}</div>
            <div v-if="data.status==='forSell'">HKD {{_.round(data.sellPrice)}}萬</div>
            <div v-if="data.status==='forRent'">HKD {{_.round(data.rentPrice)}}</div>
            <div v-if="data.status==='forSellWithRent'">HKD {{_.round(data.sellPrice)}}萬</div>
          </div>
        </div>
        <div class="row-3 description">
          {{data.property.description}}
        </div>
      </div>
      <div class="hr"></div>
      <div class="meta">
        <div>
          <img
            class="footer-icon"
            src="@/assets/web_icons/badroom.png"
          >
          <span>{{data.property.bedroom}}</span>
        </div>
        <div>
          <img
            class="footer-icon"
            src="@/assets/web_icons/livingroom.png"
          >
          <span>{{data.property.livingroom}}</span>
        </div>
        <div>
          <img
            class="footer-icon"
            src="@/assets/web_icons/bathroom.png"
          >
          <span>{{data.property.bathroom}}</span>
        </div>
        <div>
          <img
            class="footer-icon"
            src="@/assets/web_icons/grossarea.png"
          >
          <span>{{data.property.grossArea}}呎</span>
        </div>
        <div>
          <img
            class="footer-icon"
            src="@/assets/web_icons/compass.png"
          >
          <span>{{getCompassName(data.property.compass)}}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import _ from "lodash";

export default {
  name: "PropertyCard",
  computed: {
    _() {
      return _;
    }
  },
  props: {
    data: Object
  },
  methods: {
    getStatusName(s) {
      return this.$getConst("STATUS_MAPPING")[s];
    },
    getCompassName(s) {
      return this.$getConst("COMPASS_MAPPING")[s];
    },
    getImage(d) {
      const url = _.get(d, "images[0].url", "");
      if (url) {
        return `https://${url}`;
      } else {
        return "https://via.placeholder.com/500";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: inherit;
  width: 100%;
  max-width: 300px;
}
.propertyCard {
  transition: all 50ms ease-out;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.11);
  cursor: pointer;
  &:hover {
    transform: translateY(-2px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0, 0, 0, 0.11), 0 24px 46px rgba(0, 0, 0, 0.11);
  }
  user-select: none;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  // width: 368px;
  width: 100%;
  height: 346px;
  background-color: white;
  border-radius: 10px;
  > img {
    display: block;
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .detailContainer {
    text-align: left;
    flex: 1 1;
    .row-1 {
      padding: 8px;
      box-sizing: border-box;
      max-height: 43px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h5 {
        align-self: flex-start;
        margin: 0;
        & > b {
          font-size: 1.2rem;
        }
        & > span {
          margin-left: 6px;
          font-weight: normal;
        }
      }
      > div {
        &.status {
          color: white;
          padding: 4px 6px;
          border-radius: 3px;
          font-size: 0.83rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inherit;
        }
        &.status.forSellAndRent {
          background-color: #299283;
        }
        &.status.forSell {
          background-color: #4ed85d;
        }
        &.status.forRent {
          background-color: #536cca;
        }
        &.status.forSellWithRent {
          background-color: #427182;
        }
      }
    }
    .row-2 {
      padding: 0 8px;
      display: flex;
      justify-content: space-between;
      font-weight: bold;
    }
    .row-3.description {
      height: 41px;
      overflow-y: hidden;
      padding: 0 8px;
      color: #666;
      font-size: 0.85rem;
    }
  }
  .hr {
    margin: 0 8px;
    border-bottom: 1px solid black;
  }

  .meta {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-align: left;
    padding: 8px 12px;
    > div {
      display: flex;
      align-content: center;
      justify-items: center;
    }
    img.footer-icon {
      height: 18px;
      width: 18px;
    }
    span {
      line-height: 18px;
      margin-left: 2px;
      margin-right: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inherit;
    }
  }
}
</style>
